import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=74e72d5c&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=ts"
export * from "./Developer.vue?vue&type=script&lang=ts"
import style0 from "./Developer.vue?vue&type=style&index=0&id=74e72d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e72d5c",
  null
  
)

export default component.exports